// src/pages/happinessreport/components/ChartsAndDimensions.tsx
/**
 * Renderiza o gráfico comparativo por questão e as 6 dimensões (Dimension components).
 * Recebe os dados gerais e filtrados.
 */

import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import MonthReportLineChart from '../../../components/dashboard/lineChart';
import Dimension from '../../../components/dashboard/dimension';
import { StyledCardBodyOverflow, StyledCardHeader, StyledRowOverflow } from '../../../components/dashboard/attentionPoints/styles';
import { ContainerOverflowCharts } from '../styles';
import { useTranslation } from 'react-i18next';
import { QuestionnaireVersion } from '../../../i18n/questionnaire';

type Props = {
  loading: boolean;
  generalData: any;
  filteredData: any;
  questionnaireVersion: QuestionnaireVersion;
};

const ChartsAndDimensions: React.FC<Props> = ({ loading, generalData, filteredData, questionnaireVersion }) => {
  const { t } = useTranslation('reports');
  const { t: ti } = useTranslation('insights');
  
  return (
    <>
      <Row className='pb-2 pt-2'>
        <Col>
          <StyledCardBodyOverflow style={{ background: '#FFF', color: '#3C4043', overflowX: 'auto' }}>
            <StyledCardHeader style={{padding: '1rem 1.25rem', borderBottom: '2px solid #e7e8e9' }}>
              <h5 className='pb-0 mb-0'>{t('comparativeQuestions')}</h5>
            </StyledCardHeader>

            <Card.Body>
              <ContainerOverflowCharts>
                <MonthReportLineChart
                  heightSize='335px'
                  topPosition='6%'
                  heightSizeResponsive='275px'
                  topPositionResponsive='18.85%'
                  chartId='generalIfozChart'
                  generalEpData={generalData.generalEpDimension}
                  generalEngData={generalData.generalEngDimension}
                  generalRelData={generalData.generalRelDimension}
                  generalSigData={generalData.generalSigDimension}
                  generalReaData={generalData.generalReaDimension}
                  generalVitData={generalData.generalVitDimension}
                  filteredEpData={filteredData.filteredEpDimension}
                  filteredEngData={filteredData.filteredEngDimension}
                  filteredRelData={filteredData.filteredRelDimension}
                  filteredSigData={filteredData.filteredSigDimension}
                  filteredReaData={filteredData.filteredReaDimension}
                  filteredVitData={filteredData.filteredVitDimension}
                />
              </ContainerOverflowCharts>
            </Card.Body>
          </StyledCardBodyOverflow>
        </Col>
      </Row>

      <div>
        <h4 style={{ color: '#3C4043', padding: '3em 0 0 0' }}>{t('byDimension')}</h4>
      </div>

      <StyledRowOverflow className='pb-2' style={{ overflow: 'auto', minHeight: '100%' }}>
        <Col sm='12' style={{ overflow: 'auto', minWidth: '600px', minHeight: '100%', marginBottom: '1em' }}>
          <Dimension type={ti('dimension.positive')} generalData={generalData.generalEpDimension} filteredData={filteredData.filteredEpDimension} dimensionKey='0' questionnaireVersion={questionnaireVersion} />
        </Col>
      </StyledRowOverflow>

      <StyledRowOverflow className='pt-4' style={{ overflow: 'auto', minHeight: '100%' }}>
        <Col sm='12' style={{ overflow: 'auto', minWidth: '600px', minHeight: '100%', marginBottom: '1em' }}>
          <Dimension type={ti('dimension.engagement')} generalData={generalData.generalEngDimension} filteredData={filteredData.filteredEngDimension} dimensionKey='1' questionnaireVersion={questionnaireVersion} />
        </Col>
      </StyledRowOverflow>

      <StyledRowOverflow className='pt-4' style={{ overflow: 'auto', minHeight: '100%' }}>
        <Col sm='12' style={{ overflow: 'auto', minWidth: '600px', minHeight: '100%', marginBottom: '1em' }}>
          <Dimension type={ti('dimension.relationship')} generalData={generalData.generalRelDimension} filteredData={filteredData.filteredRelDimension} dimensionKey='2' questionnaireVersion={questionnaireVersion} />
        </Col>
      </StyledRowOverflow>

      <StyledRowOverflow className='pt-4' style={{ overflow: 'auto', minHeight: '100%' }}>
        <Col sm='12' style={{ overflow: 'auto', minWidth: '600px', minHeight: '100%', marginBottom: '1em' }}>
          <Dimension type={ti('dimension.meaning')} generalData={generalData.generalSigDimension} filteredData={filteredData.filteredSigDimension} dimensionKey='3' questionnaireVersion={questionnaireVersion} />
        </Col>
      </StyledRowOverflow>

      <StyledRowOverflow className='pt-4' style={{ overflow: 'auto', minHeight: '100%' }}>
        <Col sm='12' style={{ overflow: 'auto', minWidth: '600px', minHeight: '100%' , marginBottom: '1em'}}>
          <Dimension type={ti('dimension.accomplishment')} generalData={generalData.generalReaDimension} filteredData={filteredData.filteredReaDimension} dimensionKey='4' questionnaireVersion={questionnaireVersion} />
        </Col>
      </StyledRowOverflow>

      <StyledRowOverflow className='pt-4' style={{ overflow: 'auto', minHeight: '100%' }}>
        <Col sm='12' style={{ overflow: 'auto', minWidth: '600px', minHeight: '100%', marginBottom: '1em' }}>
          <Dimension type={ti('dimension.vitality')} generalData={generalData.generalVitDimension} filteredData={filteredData.filteredVitDimension} dimensionKey='5' questionnaireVersion={questionnaireVersion} />
        </Col>
      </StyledRowOverflow>
    </>
  );
};

export default ChartsAndDimensions;
